import { Actions, ActionTypes } from './actions';
import { initialState, NotificationState } from './state';

export function NotificationReducer(state = initialState, action: Actions): NotificationState {
  switch (action.type) {
    case ActionTypes.NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        loader: false,
      };
    case ActionTypes.NOTIFICATIONS_REQUEST:
      return {
        ...state,
        error: action.payload.error,
        loader: action.loader,
      };
    case ActionTypes.MARK_AS_READ:
      return {
        ...state,
      };
    case ActionTypes.MARK_AS_READ_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default: {
      return state;
    }
  }
}
